import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

const AddOptionToClauseBtn = props => (
  <Tooltip
    placement="top"
    overlay="Use this feature to add variation options to this clause in the form mode."
    align={{ offset: [0, 3] }}>
    <span
      className="add-clause-btn add-option-to-this-clause-btn"
      data-test="addoptiontoclausebtn-add-option-to-this-clause-btn"
      onMouseDown={() => props.btnAction(props.id)}
      onKeyDown={() => {}}
      role="button"
      tabIndex={0}>
      <i>
        <FontAwesomeIcon icon={["far", "layer-plus"]} />
      </i>
      Add Clause Field
    </span>
  </Tooltip>
);

export default AddOptionToClauseBtn;
